type Task<T> = () => Promise<T>

export class ThreadPool {
  private queue: Array<{ task: Task<any>; imageSize: number }> = []
  private activePromises: number = 0
  private limit: number
  private currentSize: number = 0
  private maxPoolDataSize: number = 500 * 1024 * 1024 // 500 MB in bytes

  constructor(limit: number, sizeLimit: number) {
    this.limit = limit
    this.maxPoolDataSize = sizeLimit * 1024 * 1024
  }

  add<T>(task: Task<T>, imageSize: number): Promise<T> {
    return new Promise((resolve, reject) => {
      const queuedTask = { task: () => task().then(resolve).catch(reject), imageSize }
      this.queue.push(queuedTask)
      this.next()
    })
  }

  private next() {
    if (this.activePromises >= this.limit || this.queue.length === 0) return

    // Try to find a task that can be executed without exceeding the size limit
    let index = -1
    for (let i = 0; i < this.queue.length; i++) {
      if (this.currentSize + this.queue[i].imageSize <= this.maxPoolDataSize) {
        index = i
        break
      }
    }

    if (index === -1) {
      // No suitable task found, try again later
      setTimeout(() => this.next(), 1000)
      return
    }

    // Execute the found task
    const { task, imageSize } = this.queue.splice(index, 1)[0]
    this.currentSize += imageSize
    this.activePromises++
    task().finally(() => {
      this.currentSize -= imageSize
      this.activePromises--
      this.next()
    })
  }
}
